<template>
  <div style="position: relative;">
    <el-row>
      <el-col :span="24">
        <el-table ref="requirement" :data="requirementList.Requirement.impl.dataList" :size="defaultFormItemSize" @sort-change="requirementList.Requirement.impl.onSortChange"
                  header-cell-class-name="table-header-gray"
                  highlight-current-row @current-change="requirementList.Requirement.impl.currentRowChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="requirementList.Requirement.impl.getTableIndex" />
          <el-table-column label="需求主题" prop="subjectName">
          </el-table-column>
          <el-table-column label="产业关键词" prop="keyWord">
          </el-table-column>
          <el-table-column label="需求人" prop="userName">
          </el-table-column>
          <el-table-column label="联系电话" prop="userPhone">
          </el-table-column>
          <el-table-column label="需求类型" prop="subjectTypeDictMap.name">
          </el-table-column>
          <el-table-column label="需求专家" prop="specialistIdsDictMap.name">
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="对接状态" prop="isDockingDictMap.name">
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button @click.stop="onRequirementFormClick(scope.row)" type="text" :size="defaultFormItemSize"
                         :disabled="!checkPermCodeExist('requirementList:requirementList:requirementForm')">
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="requirementList.Requirement.impl.totalCount"
            :current-page="requirementList.Requirement.impl.currentPage"
            :page-size="requirementList.Requirement.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="requirementList.Requirement.impl.onCurrentPageChange"
            @size-change="requirementList.Requirement.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="90%">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="需求主体名称" prop="Requirement.mainBody">

            <span class="input-item input-label" >{{formData.Requirement.mainBody}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="需求主体联系人" prop="Requirement.mainContact">

            <span class="input-item input-label" >{{formData.Requirement.mainContact}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="需求主体手机" prop="Requirement.mainPhone">

            <span class="input-item input-label" >{{formData.Requirement.mainPhone}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="座机" prop="Requirement.landline">

            <span class="input-item input-label" >{{formData.Requirement.landline}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电子邮箱" prop="Requirement.eMail">

            <span class="input-item input-label" >{{formData.Requirement.eMail}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="行业" >
            <span class="input-item input-label" >{{(formData.Requirement.industryIdDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="需求类型" >

            <span class="input-item input-label" >{{(formData.Requirement.subjectTypeDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="地区" >

            <span class="input-item input-label" >{{(formData.Requirement.areaIdDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址" >

            <span class="input-item input-label" >{{formData.Requirement.address}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="需求主题" >

            <span class="input-item input-label" >{{formData.Requirement.subjectName}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关键词" >
            <span class="input-item input-label" >{{formData.Requirement.keyWord}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="需求描述" >
            <span class="input-item input-label" >{{formData.Requirement.requirementDesc}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效期" >

            <span class="input-item input-label" >{{(formData.Requirement.validityDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否公开" >

            <span class="input-item input-label" >{{(formData.Requirement.isOpenDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="对接状态" >

            <span class="input-item input-label" >{{(formData.Requirement.isDockingDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="对接专家" >

            <span class="input-item input-label" >{{(formData.Requirement.specialistIdsDictMap || {}).name}}</span>

          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="附件照片" >

            <template >
              <img v-for="item in requirementForm.attachedImages.impl.fileList" :key="item.url"
                   class="table-cell-image" :src="item.url" />
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable-next-line */
  import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
  import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
  import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
  import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
  import { RequirementController, DictionaryController ,RequirementRelateController} from '@/api';
export default {
  name: 'RequirementRelateHis',
  props: {
    specialistIds: null
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      requirementList: {
        formFilter: {
          subjectName: undefined,
          subjectType: undefined
        },
        formFilterCopy: {
          subjectName: undefined,
          subjectType: undefined
        },
        Requirement: {
          impl: new TableWidget(this.loadRequirementWidgetData, this.loadRequirementVerify, true, true, 'createTime', 1)
        },
        subjectType: {
          impl: new DropdownWidget(this.loadSubjectTypeDropdownList)
        },
        isInit: false
      },
      dialogVisible: false,
      requirementForm: {
        formFilter: {
        },
        formFilterCopy: {
        },
        industryId: {
          impl: new DropdownWidget(this.loadIndustryIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        areaId: {
          impl: new DropdownWidget(this.loadAreaIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        subjectType: {
          impl: new DropdownWidget(this.loadSubjectTypeDropdownList)
        },
        validity: {
          impl: new DropdownWidget(this.loadValidityDropdownList)
        },
        isOpen: {
          impl: new DropdownWidget(this.loadIsOpenDropdownList)
        },
        attachedImages: {
          impl: new UploadWidget(5)
        },
        menuBlock: {
          isInit: false
        },
        isDocking: {
          impl: new DropdownWidget(this.loadIsDockingDropdownList)
        },
        specialistIds: {
          impl: new DropdownWidget(this.loadSpecialistIdsDropdownList)
        },

        isInit: false
      },
      formData: {
        Requirement: {

        }
      }
    }
  },
  methods: {
    onResetRequirementList () {
      this.$refs.requirementListFilter.resetFields();
      this.refreshRequirementList(true);
    },
    /**
       * 需求对接表数据获取函数，返回Promise
       */
    loadRequirementWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        requirementDtoFilter: {
          isDocking: 1,
          specialistIds: this.specialistIds
        },
        specialistId: 'userId',
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        RequirementController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.requirementList.Requirement.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.requirementList.Requirement.impl.currentRow.id, 'id');
              this.$refs.requirement.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 需求对接表数据获取检测函数，返回true正常获取数据，返回false停止获取数据
       */
    loadRequirementVerify () {
      this.requirementList.formFilterCopy.subjectName = this.requirementList.formFilter.subjectName;
      this.requirementList.formFilterCopy.subjectType = this.requirementList.formFilter.subjectType;
      return true;
    },
    /**
       * 需求类型下拉数据获取函数
       */
    loadSubjectTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictRSTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 需求类型选中值改变
       */
    onSubjectTypeValueChange (value) {
    },
    /**
       * 更新需求管理列表
       */
    refreshRequirementList (reloadData = false) {
      // alert(this.specialistIds)
      if (reloadData) {
        this.requirementList.Requirement.impl.refreshTable(true, 1);
      } else {
        this.requirementList.Requirement.impl.refreshTable();
      }
      if (!this.requirementList.isInit) {
        // 初始化下拉数据
      }
      this.requirementList.isInit = true;
    },
    /**
       * 编辑查看
       */
    onRequirementFormClick (row) {
      let params = {
        id: row.id
      };
      RequirementController.view(this, params).then(res => {
        this.formData.Requirement = {...res.data, isDatasourceInit: true};
        this.dialogVisible = true
        let attachedImagesDownloadParams = {
          id: this.formData.Requirement.id,
          fieldName: 'attachedImages',
          asImage: true
        }
        this.requirementForm.attachedImages.impl.fileList = this.parseUploadData(this.formData.Requirement.attachedImages, attachedImagesDownloadParams);
        // resolve();
      }).catch(e => {
        // reject();
      });
    },
    onResume () {
      this.refreshRequirementList();
    },
    initFormData () {
    },
    formInit () {
      this.refreshRequirementList();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
